module.exports = __webpack_public_path__ + "static/listing-back-image-2-9b603f4a145331dcade47a5595db45cf.png";